export const QR_KEY = 'qr';
export const QR_URL = import.meta.env['VITE_PUBLIC_QR_URL'];

if (!QR_URL) {
    throw new Error('NO QR_URL ENV');
}
